import { render, staticRenderFns } from "./TheRecoveryNoticeScreen.vue?vue&type=template&id=65f76c42&"
import script from "./TheRecoveryNoticeScreen.vue?vue&type=script&lang=js&"
export * from "./TheRecoveryNoticeScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports